import type { CallStrategyConfig } from '../call/callstrategy';
import { getCallStrategy } from '../call/callstrategy';
import { create } from 'zustand';
import { intl, notifyConfirm } from 'ehs-react';
import { WaitingRoomStoreApi } from './waitingRoom.store';
import { ViewStateStoreApi } from './viewState.store';
import { PortletStoreApi } from '../App';
import type { CallInfoState } from 'virtual-visit-common';
import { CallMenuStoreApi } from 'virtual-visit-common';
import { DeviceConfig, queryDevicePermissions } from 'virtual-visit-common';
import { callInfo } from '../communication/ajax';
import type { at } from '../generated/Beans';
type DevicePermissionState = at.sense.saf.infrastructure.portalutil.virtualvisit.callinfo.DevicePermissionState;
type CallInfo = at.sense.saf.infrastructure.portalutil.virtualvisit.callinfo.CallInfo;

export interface CallStore {
  callStrategyConfig?: CallStrategyConfig;
  callStatusMessage?: string;
  deviceConfig: DeviceConfig;
  startCall: () => void;
  stopCall: () => void;
  callRunning: boolean;
  callInfoStateCallback: (infoState: CallInfoState) => void;
}

export const [useCallStore, CallStateApi] = create<CallStore>((set, get) => ({
  deviceConfig: new DeviceConfig(),
  callRunning: false,
  startCall: async () => {
    console.log(
      'startCall!!!!!!!  - pre sel cam:',
      CallMenuStoreApi.getState().preselectedCamera,
      'sel cam:',
      CallMenuStoreApi.getState().selectedCamera
    );
    const onReady = () => {
      set(
        state =>
          (state.deviceConfig =
            getCallStrategy()?.getCallMenuInterface()?.getDeviceConfig() ||
            new DeviceConfig())
      );
    };
    getCallStrategy().addCallStatusMessageListener(msg => {
      set(state => (state.callStatusMessage = msg));
    });
    const callConfig = get().callStrategyConfig;
    console.log('callConfig', callConfig);
    const vInfo = WaitingRoomStoreApi.getState().visitInfo;
    const onReadyToClose = () => {
      getCallStrategy().setPreventPhysicianLeftNotification(true);
      sessionStorage.clear();
      ViewStateStoreApi.getState().nextState();
    };
    if (callConfig && vInfo) {
      console.log(
        'physicianLeftMessageDelay: ' +
          PortletStoreApi?.getState()?.configuration?.physicianLeftMessageDelay
      );
      const guestToken = ViewStateStoreApi.getState().viewStateData?.guestData
        ?.urlToken;

      const camName =
        CallMenuStoreApi.getState().selectedCamera?.name ??
        CallMenuStoreApi.getState().preselectedCamera?.name;
      console.log('start call cam name', camName);
      getCallStrategy()
        .initProviderAndStartCall(
          callConfig,
          onReadyToClose,
          PortletStoreApi.getState().configuration.physicianLeftMessageDelay,
          guestToken ? 'guest|' + guestToken : 'patient',
          get().callInfoStateCallback,
          camName
        )
        .catch(e => console.error('failed to start the call', e));
      set(state => (state.callRunning = true));
    }
  },
  stopCall: async () => {
    console.log('stopCall');
    //stop full screen mode if active
    if (document.fullscreenElement != null) {
      document.exitFullscreen();
    }
    const onConfirm = () => {
      console.log('confirm - leave call');
      getCallStrategy().stopCall();
      getCallStrategy().setPreventPhysicianLeftNotification(true);
      sessionStorage.clear();
      ViewStateStoreApi.getState().nextState();
    };
    const onReject = () => {
      console.log('reject - stay in call');
    };
    notifyConfirm({
      message: intl('virtualvisitpatientportlet.video.leave'),
      onConfirm,
      onReject,
      title: intl('virtualvisitpatientportlet.waitingroom.leave.warning')
    });

    CallMenuStoreApi.setState({
      preselectedCamera: undefined,
      preselectedMicrophone: undefined,
      preselectedSpeaker: undefined
    });
  },
  callInfoStateCallback: (callInfoState: CallInfoState) => {
    queryDevicePermissions().then(devPerm => {
      const devPermState = devPerm as DevicePermissionState;
      const cInfo: CallInfo = {
        devicePermissionState: devPermState,
        callClientActiveInAnotherTab:
          callInfoState.isCallClientActiveInAnotherTab ?? false
      };
      callInfo({
        callId: callInfoState.callId ?? '',
        callInfo: cInfo,
        additionalCallInfo: callInfoState.additionalInfo ?? '',
        url: PortletStoreApi.getState().url
      }).catch(e => console.warn('failed to send call info', e));
    });
  }
}));
